import Vue from 'vue';
import App from './App.vue';

$(document).ready(() => {
// Инициализация Vue
new Vue({
	render: h => h(App),
}).$mount('#app');
});